require("prismjs/themes/prism-tomorrow.css")

const { gtag } = require("./blog-config")

// GA는 초기 렌더 경로에서 빼고 유휴 시점(또는 첫 상호작용)에 로드한다.
// head에서 바로 실행하면 TBT에 그대로 얹힌다.
let gtagLoaded = false

const loadGtag = () => {
  if (gtagLoaded || !gtag) return
  gtagLoaded = true

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }
  window.gtag("js", new Date())
  window.gtag("config", gtag, { send_page_view: true })

  const s = document.createElement("script")
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${gtag}`
  document.head.appendChild(s)
}

// gatsby-ssr.js가 media="print"로 심어둔 장식용 폰트를 첫 페인트 이후에 적용한다.
// head에서 바로 media='all'로 뒤집으면 스타일시트가 다시 렌더 블로킹이 되어
// media="print" 트릭이 무효화된다(FCP 862ms 손해로 실측됨).
const activateLazyStyles = () => {
  document.querySelectorAll("link[data-lazy-style]").forEach(link => {
    link.media = "all"
  })
}

exports.onClientEntry = () => {
  if (typeof window === "undefined") return

  const defer = cb => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(cb, { timeout: 3000 })
    } else {
      window.setTimeout(cb, 2000)
    }
  }

  // 폰트는 GA보다 먼저, 다만 첫 페인트 뒤에
  window.requestAnimationFrame(activateLazyStyles)
  defer(loadGtag)
}

exports.onRouteUpdate = ({ location }) => {
  // 첫 페이지뷰는 config가 보내므로, 클라이언트 라우팅 이동만 추가 전송
  if (!gtagLoaded || typeof window.gtag !== "function") return
  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search,
  })
}
